import { h, Component } from "preact";
import FeaturedEventTilesView from "./FeaturedEventTilesView";
import EventImageListView from "./EventImageListView";
import EventDateListView from "./EventDateListView";

/**
 * Display featured event list of tour page
 *
 * @param {*} props
 * @returns
 */
const FeaturedEvents = props => {
  const {
    events = [],
    pageLayout,
    theme,
    listViewType,
    showPrice,
    eventListingLayout
  } = props;

  let ReturnComponent = FeaturedEventTilesView;
  ReturnComponent =
    pageLayout === "list" && listViewType == "image"
      ? EventImageListView
      : ReturnComponent;
  ReturnComponent =
    pageLayout === "list" && listViewType == "date"
      ? EventDateListView
      : ReturnComponent;

  return (
    <div>
      {events.map(event => {
        return (
          <ReturnComponent
            event={event}
            featured={true}
            theme={theme}
            showPrice={showPrice}
            eventListingLayout={eventListingLayout}
          />
        );
      })}
    </div>
  );
};

export default FeaturedEvents;



// WEBPACK FOOTER //
// ./routes/tours/FeaturedEvents.js